













































































import Vue from 'vue';
import { ListMaintenanceService } from '@/services/ListMaintenanceService';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { BuiltInListConfigurationModel, BuiltInListItemModel, EditListItemSettingsModel } from '@/types/models/listMaintenance';
import { BvTableFieldArray } from 'bootstrap-vue';
import {
  ColourVariantType,
  Configuration,
  DefaultFieldDefinitions,
  TableFilterModel,
  TableSortModel,
  SchemaModel,
  ComponentPropertiesModel,
  ListModel,
  Dictionary,
  listMaintenanceConstants,
  ModalConstants
} from '@/types';
import { MStoreTableUtils, SelectableTableUtils } from '@/utils';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import MStoreColumnFilter from '@/components/shared/Table/MStoreColumnFilter.vue';
import BuiltInListItem from '@/components/configuration/listMaintenance/BuiltInListItem.vue';
import { ValidationModel } from '@/types/models/validation/ValidationModel';
import { ModalHelpers } from '@/mixins';
import { ListItemFieldListType } from '@/types/enums/configuration/listMaintenance/ListItemFieldListType';
import { ListService } from '@/services/ListService';

export default Vue.extend({
  name: 'MaintainBuiltInListItems',
  props: {},
  data() {
    return {
      isLoading: true,
      builtInListConfiguration: {} as BuiltInListConfigurationModel,
      selectedItemKeys: [],
      isDeletingItems: false,
      sortOptions: [],
      filterOptions: [],
      itemsPerPage: 40,
      currentPage: 1,
      showFilters: false,
      showSorting: false,
      appliedFilterOptions: [],
      appliedSortOptions: [],
      selectedListItemSchema: [] as SchemaModel[],
      selectedListItem: {} as BuiltInListItemModel,
      showListItemModal: false,
      isSaveListLoading: false,
      addEditListItemModalTitle: 'Add List Item',
      isListItemListLoading: false
    };
  },
  computed: {
    headerText(this: any) {
      return (this.builtInListConfiguration as BuiltInListConfigurationModel).description;
    },
    itemsSelected(this: any) {
      return Boolean((this.selectedItemKeys as []).length);
    },
    filterFields(this: any) {
      return (this.builtInListConfiguration as BuiltInListConfigurationModel).columns;
    },
    filteredSortedItems(this: any) {
      const allItems = this.builtInListConfiguration.listItems;
      const filterOptions = this.appliedFilterOptions;
      const sortOptions = this.appliedSortOptions;
      const filteredItems = MStoreTableUtils.applyDefaultFiltering(allItems, filterOptions);
      const filteredSortedItems = MStoreTableUtils.applyDefaultSorting(filteredItems, sortOptions);
      return filteredSortedItems;
    }
  },
  methods: {
    async initialise(this: any) {
      this.builtInListConfiguration = await ListMaintenanceService.getBuiltInListItemsAsync(this.BUILT_IN_LIST_ID);
    },
    async addItem(this: any) {
      this.isAddOperation = true;
      this.selectedListItem = { listId: this.BUILT_IN_LIST_ID } as BuiltInListItemModel;
      await this.mapListItemToSchemaAsync(this.selectedListItem);
      this.addEditListItemModalTitle = 'Add List Item';
      this.showListItemModal = true;
    },
    async editItem(this: any, item: any) {
      this.isAddOperation = false;
      this.selectedListItem = { ...item };
      await this.mapListItemToSchemaAsync(item);
      this.addEditListItemModalTitle = 'Edit List Item';
      this.showListItemModal = true;
    },
    async deleteItems(this: any) {
      const amountOfItemsToDelete = this.selectedItemKeys?.length;
      if (!amountOfItemsToDelete) {
        return;
      }
      if (
        await ModalHelpers.methods.showConfirmationModalAsync(this.$bvModal, `Are you sure you want to delete ${amountOfItemsToDelete} items?`, {
          okVariant: ColourVariantType.Danger,
          cancelVariant: ColourVariantType.Primary,
          okTitle: ModalConstants.deleteConfirmationText
        })
      ) {
        this.isDeletingItems = true;
        const updatedListItems = await ListMaintenanceService.deleteMafListItemsAsync(this.BUILT_IN_LIST_ID, this.selectedItemKeys.map(Number));
        this.builtInListConfiguration.listItems = [...updatedListItems];
        SnotifyConfiguration.showSuccess(`Successfully deleted ${amountOfItemsToDelete} items`);
        this.isDeletingItems = false;
      }
    },
    onRowSelected(this: any, itemKey: string) {
      this.selectedItemKeys = SelectableTableUtils.DefaultSelectItem(this.selectedItemKeys, itemKey);
    },
    onRowsSelected(this: any, itemKeys: string[]) {
      this.selectedItemKeys = SelectableTableUtils.DefaultSelectItems(this.selectedItemKeys, itemKeys);
    },
    onPaginatedItemsUpdated(this: any, updatedItemKeys: string[]) {
      this.selectedItemKeys = SelectableTableUtils.DefaultTableItemsUpdated(this.selectedItemKeys, updatedItemKeys);
    },
    updateFilter(this: any, index: number, filter: TableFilterModel) {
      Vue.set(this.filterOptions, index, filter);
    },
    addFilter(this: any) {
      this.filterOptions = [...(this.filterOptions as TableFilterModel[]), { key: '', columnFilterType: '' }] as TableFilterModel[];
    },
    clearFilters(this: any) {
      const filterFields: TableFilterModel[] = this.filterOptions;
      this.filterOptions = filterFields.map(({ key, columnFilterType }) => ({
        key,
        columnFilterType,
        value: ''
      }));
    },
    resetFilters(this: any) {
      this.filterOptions = [];
      this.applyFilters();
    },
    applyFilters(this: any) {
      this.appliedFilterOptions = [...this.filterOptions];
    },
    removeFilter(this: any, index: number) {
      this.filterOptions.splice(index, 1);
    },
    onSortingApplied(this: any) {
      this.sortItems();
    },
    updateSortItem(this: any, index: number, sortOption: TableSortModel) {
      Vue.set(this.sortOptions, index, { ...sortOption });
    },
    addSortItem(this: any, sortOption?: TableSortModel) {
      this.sortOptions.push(sortOption || { sortingKey: '', isSortingAscending: true });
    },
    deleteSortOption(this: any, index: number) {
      this.sortOptions.splice(index, 1);
    },
    resetSort(this: any) {
      this.sortOptions = [] as TableSortModel[];
      this.sortItems();
    },
    sortItems(this: any) {
      const usedFields = new Set();
      for (const option of this.sortOptions) {
        if (option.sortingKey === '') {
          SnotifyConfiguration.showError('Not all sorting options have a field selected');
          return;
        }
        if (usedFields.has(option.sortingKey)) {
          const columnDescription = this.queueColumns.find((x: any) => x.key === option.sortingKey).label;
          SnotifyConfiguration.showError(`Cannot sort on the same field (${columnDescription}) twice`);
          return;
        } else {
          usedFields.add(option.sortingKey);
        }
      }

      this.appliedSortOptions = [...this.sortOptions];
    },
    onShowSorting(this: any) {
      this.showSorting = !this.showSorting;
    },
    onShowFilters(this: any) {
      this.showFilters = !this.showFilters;
    },
    onUpdateItemsPerPage(this: any, _: string, value: number) {
      this.itemsPerPage = value;
    },
    onUpdateCurrentPage(this: any, _: string, value: number) {
      this.currentPage = value;
    },
    returnToLists() {
      this.$router.push({ name: Configuration.ListMaintenance.ListMaintenance.name });
    },
    async mapListItemToSchemaAsync(this: any, listItem: any) {
      this.selectedListItemSchema = [];
      for (const column of this.builtInListConfiguration.columns) {
        const editListItemSettings = this.builtInListConfiguration.builtInListAdditionalConfiguration?.editListItemSettings.find((x: EditListItemSettingsModel) => x.listItemFieldId === column.key);
        if (editListItemSettings) {
          if (editListItemSettings.listType === ListItemFieldListType.LocalListDataFilterEnabled) {
            this.isListItemListLoading = true;
            const linkedList: ListModel = await ListService.getListAsync(editListItemSettings.listId, '', false, {} as Dictionary<any>);
            this.isListItemListLoading = false;
            this.selectedListItemSchema.push(
              this.createMStoreFormSelectTableSchemaModel(column.label, listItem[column.key], column.key, linkedList, column.key === this.builtInListConfiguration.primaryKey)
            );
          } else {
            this.selectedListItemSchema.push(
              this.createMstoreFormLookUpSchemaModel(column.label, listItem[column.key], column.key, column.key === this.builtInListConfiguration.primaryKey, editListItemSettings.listId)
            );
          }
        } else {
          const list: ListModel = {
            key: column.key,
            text: column.label,
            headers: [{ data: column.key, title: column.label, id: '' }],
            list: this.builtInListConfiguration.listItems,
            totalRow: this.builtInListConfiguration.listItems,
            resultType: 2,
            id: 0,
            listDataResultTypeMessage: ''
          };
          this.selectedListItemSchema.push(
            this.createMStoreFormSelectTableSchemaModel(column.label, listItem[column.key], column.key, list, column.key === this.builtInListConfiguration.primaryKey)
          );
        }
      }
    },
    createMStoreFormSelectTableSchemaModel(this: any, listItemLabel: string, listItemValue: string, listItemId: string, list: ListModel, isRequired: boolean) {
      return {
        id: listItemId,
        value: listItemValue,
        label: listItemLabel,
        componentProperties: {
          componentName: 'MStoreFormSelectTable',
          displayField: list.key,
          valueField: list.key,
          allowTypedValue: true,
          filterDisabled: false,
          list,
          formId: `maintain-list-${this.BUILT_IN_LIST_ID}`
        } as ComponentPropertiesModel,
        validation: { maxLength: listMaintenanceConstants.listItemMaxLength, required: isRequired } as ValidationModel,
        readonly: false,
        isDisabled: false
      } as SchemaModel;
    },
    createMstoreFormLookUpSchemaModel(this: any, listItemLabel: string, listItemValue: string, listItemId: string, isRequired: boolean, listId: boolean) {
      return {
        id: listItemId,
        value: listItemValue,
        label: listItemLabel,
        componentProperties: {
          componentName: 'MStoreFormLookup',
          listId,
          isLoading: this.isLoading,
          fieldLabel: listItemLabel,
          fieldId: listItemId,
          isReadonly: false,
          hasInitialList: false,
          actionButtonComponentName: '',
          ignoreIsRequired: false,
          filterDisabled: false,
          allowTypedValue: true,
          maxItemsBeforeScroll: 10,
          formId: `maintain-list-${this.BUILT_IN_LIST_ID}`
        } as ComponentPropertiesModel,
        validation: { maxLength: listMaintenanceConstants.listItemMaxLength, required: isRequired } as ValidationModel,
        readonly: false,
        isDisabled: false
      } as SchemaModel;
    },
    listItemCancelled() {
      this.showListItemModal = false;
    },
    async saveListItemAsync(this: any) {
      this.isSaveListLoading = true;
      this.mapSchemaChangesToBuiltInListItem(this.selectedListItemSchema);
      try {
        if (this.isAddOperation) {
          this.builtInListConfiguration = await ListMaintenanceService.createBuiltInListItemAsync(this.selectedListItem);
          SnotifyConfiguration.showSuccess('Successfully added list item');
        } else {
          this.builtInListConfiguration = await ListMaintenanceService.updateBuiltInListItemAsync(this.selectedListItem);
          SnotifyConfiguration.showSuccess('Successfully updated list item');
        }
        this.showListItemModal = false;
      } catch (error) {
        if (error instanceof Error) {
          SnotifyConfiguration.showError(error.message);
        }
      } finally {
        this.isSaveListLoading = false;
      }
    },
    listItemChanged(this: any, schema: SchemaModel) {
      this.selectedListItemSchema = schema;
    },
    mapSchemaChangesToBuiltInListItem(this: any, schemas: SchemaModel[]) {
      schemas.map((s: SchemaModel) => {
        this.selectedListItem[s.id] = s.value;
      });
    }
  },
  async mounted(this: any) {
    await this.initialise();
    this.TABLE_FIELDS = [DefaultFieldDefinitions.Actions, ...(this.builtInListConfiguration as BuiltInListConfigurationModel).columns] as BvTableFieldArray;
    this.isLoading = false;
  },
  created(this: any) {
    this.BUILT_IN_LIST_ID = Number(this.$route.params.listId);
  },
  components: { MStoreTable, LoadingSpinner, MStoreSpinnerButton, MStoreColumnFilter, BuiltInListItem }
});
